import { LPBondsOrderbookApi } from 'clientSDK';

const api = new LPBondsOrderbookApi();

export default {
  create: async (body) => await api.create(body),

  cancelOrder: async (body) => await api.cancelOrder(body),

  getOrder: async (hashkey) => await api.getOrder(hashkey),

  getOrders: async (hashkeys) => await api.getOrders(hashkeys),

  getOffersMade: async ({ makerAddress }) => await api.getOffersMade({ makerAddress }),

  createBidOrders: async (body) => await api.createBidOrders(body),
};
